import { render, staticRenderFns } from "./BargainTenantComponent.vue?vue&type=template&id=1b54ec78"
import script from "./BargainTenantComponent.vue?vue&type=script&lang=js"
export * from "./BargainTenantComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports